import React, { FC } from 'react';
import styled from 'styled-components';

import { YandexMoneyMethod } from '~/api/finance/financeApiTypes';
import { choosePaySelector } from '~/feature/finance/BuyingSteps/ChoosePay/choosePay.selector';
import { useAppSelector } from '~/store';

import { DefaultMethodPaymentParams, MethodPaymentTemplate } from './MethodPaymentTemplate';

interface YandexMoneyMethodPaymentProps extends DefaultMethodPaymentParams {
  method: YandexMoneyMethod;
}

export const YandexMoneyMethodPayment: FC<YandexMoneyMethodPaymentProps> = ({
  method,
  onCheck,
  ...props
}) => {
  const { activeMethod } = useAppSelector(choosePaySelector);

  return (
    <MethodPaymentTemplate
      Logo={(
        <SCIcon
          src="/icon/components/YandexMoneyMethodPayment/ioIcon.svg"
        />
      )}
      Text={(
        <>
          {method.name}
        </>
      )}
      onCheck={() => {
        if (onCheck) {
          onCheck(method);
        }
      }}
      {...props}
    />
  );
};

const SCIcon = styled.img`
  width: 48px;
  height: 48px;
`;
